import noUiSlider from 'nouislider';
import BaseComponent from 'scripts/BaseComponent.js';
import 'nouislider/dist/nouislider.css';

export default class PriceFilter extends BaseComponent {
  constructor(component) {
    super(component);
    this.debug = false;

    this.refs = {
      priceSlider: '.js-priceSlider',
      minValue: '.js-minValue',
      maxValue: '.js-maxValue',
    };

    this.dom = {
      $component: component,
      $priceSlider: this.$get(this.refs.priceSlider),
      $minValue: this.$get(this.refs.minValue),
      $maxValue: this.$get(this.refs.maxValue),
    };

    this.state = {
      startValue: null,
      endValue: null,
      maxValue: null,
      setPriceFiltersEvent: 'setpricefilters',
      updatePriceFilterEvent: 'updatepricefilters',
    };

    this.mount();
    this.init();
  }

  mount() {
    const { state } = this;
    super.mount();

    this.setOnCustomEvent(state.updatePriceFilterEvent, this.updatePriceFilter);
  }

  init() {
    this.setDefaultValues();
    this.initSlider();
  }

  setDefaultValues() {
    const { dom, state } = this;
    const { start, end, max } = dom.$component.dataset;

    state.startValue = parseInt(start, 10);
    state.endValue = parseInt(end, 10);
    state.maxValue = parseInt(max, 10);
  }

  initSlider() {
    const { dom, state } = this;

    noUiSlider.create(dom.$priceSlider, {
      start: [state.startValue, state.endValue],
      connect: true,
      step: 10,
      range: {
        min: 0,
        max: state.maxValue,
      },
    });
    dom.$priceSlider.noUiSlider.on('update', this.slideUpdate.bind(this));
    dom.$priceSlider.noUiSlider.on('end', this.slideEnd.bind(this));
  }

  slideUpdate() {
    const { dom } = this;
    const { currencySymbol } = dom.$component.dataset;
    const [min, max] = dom.$priceSlider.noUiSlider.get();

    dom.$minValue.textContent = `${currencySymbol}${parseInt(min, 10).toLocaleString()}`;
    dom.$maxValue.textContent = `${currencySymbol}${parseInt(max, 10).toLocaleString()}`;
  }

  slideEnd() {
    const { dom, state } = this;
    const { minParam, maxParam } = dom.$component.dataset;
    const [min, max] = dom.$priceSlider.noUiSlider.get();

    const priceFilters = [{
      name: minParam,
      value: parseInt(min, 10),
    }, {
      name: maxParam,
      value: parseInt(max, 10),
    }];

    this.dispatch(state.setPriceFiltersEvent, { priceFilters });
  }

  updatePriceFilter({ detail }) {
    const { dom, state } = this;
    const start = detail.start || 0;
    const end = detail.end || state.maxValue;

    dom.$priceSlider.noUiSlider.set([start, end]);
  }
}
